var CATEGORY_MAP = {
	"About Me": require("cloze/about_me.svg"),
	"Animals": require("cloze/close_up_mode.svg"),
	"Fine Arts and Crafts": require("cloze/stack_of_photos.svg"),
	"Cars, Trucks &  Other Motor Vehicles": require("cloze/in_transit.svg"),
	"Computers": require("cloze/computers.svg"),
	"Do the Right Thing": require("cloze/decision.svg"),
	"Family": require("cloze/conference_call.svg"),
	"Style & Fashion": require("cloze/flash_on.svg"),
	"General": require("cloze/document.svg"),
	"Law & Politics": require("cloze/genealogy.svg"),
	"Health": require("cloze/biotech.svg"),
	"Places and History": require("cloze/library.svg"),
	"Music": require("cloze/music.svg"),
	"News Today": require("cloze/news.svg"),
	"On Stage and Screen": require("cloze/film_reel.svg"),
	"Our Society": require("cloze/mind_map.svg"),
	"Religion": require("cloze/entering_heaven_alive.svg"),
	"Science and Math": require("cloze/idea.svg"),
	"School": require("cloze/graduation_cap.svg"),
	"Spooky Stuff": require("cloze/biohazard.svg"),
	"Sports and Games": require("cloze/sports_mode.svg"),
	"Stories": require("cloze/reading.svg"),
	"Travel & Transportation": require("cloze/panorama.svg"),
	"Travel": require("cloze/panorama.svg"),
	"The Earth": require("cloze/globe.svg"),
	"Environment": require("cloze/globe.svg"),
	"Work & Careers": require("cloze/department.svg"),
	"Work & Jobs": require("cloze/department.svg"),
	"Business & Industry": require("cloze/factory.svg"),
	"World of Business": require("cloze/department.svg"),
};

var DEFAULT_ICON = require("cloze/file.svg");

var Icons = {
	getIcon: (catName) => {
		if (catName in CATEGORY_MAP) {
			return CATEGORY_MAP[catName];
		} else {
			return DEFAULT_ICON;
		}
	}
}

module.exports = Icons;


// WEBPACK FOOTER //
// ./modules/components/cloze/ClozeIcons.js